import Footer from 'src/components/common/footer';
import Logo from 'src/components/common/logo';

import { LogoSize } from 'src/constants';
import type { ErrorLayoutProps } from './error-layout.props';

import './error-layout.scss';

const ErrorLayout = ({ children }: ErrorLayoutProps) => (
  <div className="error-layout">
    <div className="error-layout__content">
      <Logo size={LogoSize.BIG} />

      <div className="error-layout__main">{children}</div>
    </div>

    <Footer className="error-layout__footer" />
  </div>
);

export default ErrorLayout;
